import { Progress } from '@heidi/design-system/progress';
import { TypographyCaption, TypographyP2 } from '@heidi/design-system/typography';
import { Timer } from 'lucide-react';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { MAX_DURATION_WARNING_MS } from '../constants';
import { dictationIntlMessages } from '../dictation-intl-messages';

interface MaxDurationApproachingContentProps {
  countdownMs?: number;
}

export const MaxDurationApproachingContent = ({
  countdownMs = MAX_DURATION_WARNING_MS,
}: MaxDurationApproachingContentProps) => {
  const [progressValue, setProgressValue] = useState(100);

  useEffect(() => {
    const startTime = performance.now();
    let rafId: number;

    const tick = () => {
      const elapsed = performance.now() - startTime;
      const remaining = Math.max(0, countdownMs - elapsed);
      const percentage = (remaining / countdownMs) * 100;
      setProgressValue(percentage);

      if (percentage > 0) {
        rafId = requestAnimationFrame(tick);
      }
    };

    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [countdownMs]);

  return (
    <>
      <Timer size={20} className="shrink-0 text-text-secondary" />
      <div className="flex flex-1 flex-col gap-0.5">
        <TypographyP2 className="text-text-primary">
          <FormattedMessage {...dictationIntlMessages.maxDurationApproachingTitle} />
        </TypographyP2>
        <TypographyCaption className="text-text-secondary">
          <FormattedMessage {...dictationIntlMessages.maxDurationApproachingSubtitle} />
        </TypographyCaption>
      </div>
      <Progress
        value={progressValue}
        className="absolute bottom-0 left-0 h-1 w-full rounded-lg bg-background-secondary [&>div]:bg-background-primary"
      />
    </>
  );
};
